












import VueOptions from '@utils/VueOptions'
import AudienceCreativeResourceList from '@superComponents/AudienceCreative/AudienceCreativeResourceList'

settings =
  name: 'AudienceCreativeList'

  resources:
    audience_creatives:
      resourceName: 'audience_creative'
      slug: 'audience_creatives'
      infinityScroll: true

  vue:
    components: {
      AudienceCreativeResourceList,
    }

    computed:
      actionsForAudienceCreatives: ->
        fetchResource: @fetchResource
        bulkEdit: @bulkEdit
        show: @show
        edit: @edit
        preview: @preview

    mounted: ->
      @$refs.audienceCreativeResourceList.refreshInfinityScroll()

    methods:
      fetchResource: (state, resourceKey, data = {}, options = {}) ->
        @fetchInfinity state, resourceKey, data, options

      bulkEdit: (audienceCreatives) ->
        query = { audienceCreatives }
        @$router.push { name: 'AudienceCreativeBulkEditPage', query }

      show: (audienceCreative) ->
        params = { audienceCreativeId: audienceCreative.id }
        @$router.push { name: 'AudienceCreativeShowPage', params }

      edit: (audienceCreative) ->
        params = { audienceCreativeId: audienceCreative.id }
        query = { step: 'experience' }
        @$router.push { name: 'AudienceCreativeEditPage', params, query }

      preview: (audienceCreative) ->
        params = { audienceCreativeId: audienceCreative.id }
        @$router.push { name: 'AudienceCreativePreviewPage', params }

export default VueOptions.vue settings
